import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import { useSelector } from 'react-redux';
import Button from '../../Button';

const WebformActions = (props) => {
  const { entity, pages, onPreviousPage, currentPage, handleSubmit } = props;

  const isSubmitting = useSelector((state) => state.getIn(['uiInternal', 'webformSubmitting']));

  const wrapperClassNames = c('WebformComponent__submit', entity.getIn(['#attributes', 'class', 0], ''));
  const elementClassNames = c('Button', entity.getIn(['#submit__attributes', 'class', 0], { loading: isSubmitting }));

  const collectInitialValuesFlat = (data) => {
    let output = new Immutable.List();
    const mappedEntity = Immutable.fromJS(data);
    output = output.push(mappedEntity.get('#webform_key'));

    // Collect child items.
    let children = Immutable.fromJS(data);
    children.keySeq().forEach((k) => {
      if (k.indexOf('#') === 0) {
        children = children.delete(k);
      }
    });

    children.entrySeq().forEach(([key, e]) => {
      const col = collectInitialValuesFlat(e);
      output = output.merge(col);
    });

    return output;
  };
  const onNextButton = () => {
    const { setFieldTouched, validateForm, entities, onNextPage, handleSubmit: handleNextSubmit } = props;

    // Determine all children in this page.
    const fieldsInThisPage = collectInitialValuesFlat(entities);

    validateForm()
      .then((validation) => {
        let validated = true;

        Immutable.fromJS(validation).keySeq().forEach((invalidField) => {
          // Check if this field is contained by this page.
          if (fieldsInThisPage.contains(invalidField)) {
            validated = false;
            setFieldTouched(invalidField);
          }
        });

        if (validated) {
          if (currentPage !== pages.last()) {
            onNextPage();
          } else {
            handleNextSubmit();
          }
        }
      });
  };
  // Check if we should use the page labels or the submit actions  per page labels.
  let previousLabel = false;
  let nextLabel = false;
  if (entity.get('#wizard_previous__label')) {
    previousLabel = entity.get('#wizard_previous__label');
  }
  if (entity.get('#wizard_next__label')) {
    nextLabel = entity.get('#wizard_next__label');
  } else if (entity.get('#submit__label')) {
    nextLabel = entity.get('#submit__label');
  }

  let onClickPrevious = () => {};
  let onClickNext = handleSubmit;
  if (pages.size !== 0) {
    onClickPrevious = onPreviousPage;
    onClickNext = onNextButton;
  }

  return (
    <div className={wrapperClassNames}>
      {
        previousLabel && (
          <Button className={elementClassNames} type="button" onClick={onClickPrevious}>
            {previousLabel}
          </Button>
        )
      }
      {
        nextLabel && (
          <Button className={elementClassNames} type="button" onClick={onClickNext} disabled={isSubmitting}>
            {nextLabel}
          </Button>
        )
      }
    </div>
  );
};

export default WebformActions;
